import { registerPlugin } from '@capacitor/core';

import { LifecyclePluginInterface } from './definitions';
import { CAPACITOR_LIFECYCLE_PLUGIN } from '../pluginConstants';

const LifecyclePlugin = registerPlugin<LifecyclePluginInterface>(CAPACITOR_LIFECYCLE_PLUGIN);

export * from './definitions';
export { LifecyclePlugin };
